import React from 'react'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import {connect} from 'react-redux'
import FormControl from '@mui/material/FormControl'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import Autocomplete from 'components/Autocomplete'
import {fieldtype} from 'utils/enums/fieldtype'
import {fetchFilterOptions, resetFilterOptions} from 'modules/linkedfield/actions'

const Filters = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
`

const FieldTypes = [
    fieldtype.text,
    fieldtype.textarea,
    fieldtype.email,
    fieldtype.phone,
    fieldtype.datetime,
    fieldtype.url,
    fieldtype.number
]

function isCustomTemplate(template, entity) {
    let tpl = `${template}`
    if (template && entity) {
        let count = 0
        entity.fields.forEach(field => {
            const value = `<%= c${field.id} %>`
            if (tpl.indexOf(value) > -1) {
                tpl = tpl.replace(value, '')
                count++;
            }
        })
        return count !== 1 || !!tpl
    }
    return false
}

function decodeTemplate(template, entity) {
    if (template && entity) {
        let tpl = `${template}`
        entity.fields.forEach(field => {
            tpl = tpl.replace(new RegExp(`<%= c${field.id} %>`, 'g'), `@${field.singular}`)
        })
        return tpl;
    }
    return ''
}

function encodeTemplate(template, entity) {
    if (template && entity) {
        const fields = [...entity.fields].sort((a, b) => a.singular.length > b.singular.length ? -1 : 1)
        fields.forEach(field => {
            template = template.replace(new RegExp(`@${field.singular}`, 'g'), `<%= c${field.id} %>`)
        })
        return template.trim()
    }
    return ''
}

class LinkedFieldConfig extends React.Component {
    constructor(props) {
        super(props)

        const table = props.foreignerEcn ? props.foreignerEcn : props.entities[0].id
        const tableFields = this.getTableFields(table)
        const entity = props.entities.find(e => e.id === table)

        this.state = {
            create: false,
			filters: props.config.filters || [],
			forbidRepetitions: props.config.forbidRepetitions || false,
            custom: isCustomTemplate(props.linkedTemplate, entity),
            field: props.foreignerFcns && props.foreignerFcns.length ? props.foreignerFcns[0] : tableFields[0].id,
            title: props.fieldName,
            template: decodeTemplate(props.linkedTemplate, entity),
            tableFields,
            table
        }
    }

	componentDidMount() {
		this.props.fetchFilterOptions(this.props.originEntity, this.state.table)
	}

	componentWillUnmount() {
		this.props.resetFilterOptions()
	}

    handleChange = (event, data) => {
		if (event.target.name === 'filters') {
			const filters = [...this.state.filters]
			const originFieldId = data.originField ? data.originField.id : data.originField

			if (event.target.checked) {
				filters.push({
					originFieldId,
					foreignFieldId: data.foreignField.id
				})
			} else {
				const index = filters.findIndex(obj =>
					obj.originFieldId === originFieldId &&
					obj.foreignFieldId === data.foreignField.id)

				filters.splice(index, 1)
			}

			this.setState({
				filters
			})
		} else if (event.target.name === 'table') {
            const entity = this.props.entities.find(item => item.id === event.target.value)
            const tableFields = this.getTableFields(entity.id)
            this.setState({
                field: tableFields[0].id,
                template: '',
                tableFields,
				table: event.target.value,
				filters: []
            })
        } else {
			this.setState({
				[event.target.name]: event.target.value
			})
		}
    }

    changeType = () => {
        let template = this.state.template
        if (this.state.custom) {
            const entity = this.props.entities.find(e => e.id === this.state.table)
            template = encodeTemplate(template, entity)
        }
        this.props.changeTypeToLinked(this.state.create ? {
				main: {
                	singular: this.state.title
            	},
				filters: {
					filters: this.state.filters,
					forbidRepetitions: this.state.forbidRepetitions
				}
			} : this.state.custom ? {
				main: {
					entityId: this.state.table,
					linkedTemplate: template
				},
				filters: {
					filters: this.state.filters,
					forbidRepetitions: this.state.forbidRepetitions
				}
			} : {
				main: {
					entityId: this.state.table,
					fieldId: this.state.field,
				},
				filters: {
					filters: this.state.filters,
					forbidRepetitions: this.state.forbidRepetitions
				}
			}
        )

        this.props.onClose()
        this.props.handleCloseMenu()
    }

    getTableFields = (tableId) => {
        const table = this.props.entities.find(entity => entity.id === tableId)
        const fields = table.fields.filter(item => FieldTypes.indexOf(item.uiType) !== -1)
        return fields.map(field => { return { id: field.id, singular: field.singular } })
    }

    getOptions = () => {
        const options = this.state.tableFields.map(field => field.singular)
        return options.filter((value, index, self) => self.indexOf(value) === index)
    }

    render() {
        const {intl, filters, entities} = this.props

        return (
            <React.Fragment>
                <DialogTitle>
                    {this.props.foreignerEcn ? intl.formatMessage({id: "config.linked_field_update_title"}) : intl.formatMessage({id: "config.linked_field_create_title"})}
                </DialogTitle>
                <DialogContent>
                    {this.state.create ?
                        <TextField variant="standard"
                            onChange={this.handleChange}
                            name='title'
                            label={intl.formatMessage({id: "config.linked_field_new_table"})}
                            sx={{
								width: '100%',
								marginBottom: '20px'
							}}
                            defaultValue={this.state.title}
                            InputLabelProps={{
                                shrink: true
                            }}
                        /> :
                        <FormControl
							variant="standard"
							sx={{
								width: '100%',
								marginBottom: '20px'
							}}
						>
                            <InputLabel>{intl.formatMessage({id: "config.linked_field_label_to"})}</InputLabel>
                            <Select
                                value={this.state.table}
                                disabled={!!this.props.foreignerEcn}
                                onChange={this.handleChange}
                                inputProps={{
                                    name: 'table'
                                }}
                            >
                                {entities.map((item, index) =>
                                    <MenuItem key={index} value={item.id}>
                                        {item.singular}
                                    </MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    }
                    {!this.props.foreignerEcn &&
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.create}
                                    onChange={(e) => this.setState({ create: e.target.checked, custom: false })}
                                />
                            }
                            label={intl.formatMessage({id: "config.linked_field_create"})}
                        />
                    }
                    {!this.state.create && !this.state.custom &&
                        <FormControl
							variant="standard"
							sx={{
								width: '100%',
								margin: '20px 0'
							}}
						>
                            <InputLabel>{intl.formatMessage({id: "config.linked_field_label_to_field"})}</InputLabel>
                            <Select
                                value={this.state.field}
                                onChange={this.handleChange}
                                inputProps={{
                                    name: 'field'
                                }}
                            >
                                {entities.find(entity => entity.id === this.state.table).fields.map((item, index) =>
                                    FieldTypes.indexOf(item.uiType) !== -1 &&
                                    <MenuItem key={index} value={item.id}>
                                        {item.singular}
                                    </MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    }
                    {!this.state.create && this.state.custom &&
                        <Autocomplete
                            style={{margin: '20px 0'}}
                            value={this.state.template}
                            label={intl.formatMessage({id: "config.linked_field_template"})}
                            onChange={(value) => this.setState({template: value})}
                            options={this.getOptions()}
                            component='input'
                        />
                    }
                    {!this.state.create &&
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.custom}
                                    onChange={(e) => this.setState({ custom: e.target.checked })}
                                />
                            }
                            label={intl.formatMessage({id: "config.use_custom_template"})}
                        />
                    }
					<Filters>
						{filters.map((item, index) => {
							const table = entities.find(entity => entity.id === this.state.table).singular
							const checked = !!this.state.filters.find(obj =>
								obj.originFieldId === (item.originField ? item.originField.id : item.originField) &&
								obj.foreignFieldId === item.foreignField.id)

							return <FormControlLabel
								key={index}
								control={
									<Checkbox
										checked={checked}
										onChange={(e) => this.handleChange(e, item)}
										name='filters'
									/>
								}
								label={intl.formatMessage({
									id: item.originField ? "config.filter_rule" : "config.filter_rule_null_origin"
								},{
									foreign: `"${table} - ${item.foreignField.singular}"`,
									field: item.originField ?
										`"${item.originField.singular}"`: item.foreignField.singular
								})}
							/>
						})}
						<FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.forbidRepetitions}
                                    onChange={(e) => this.setState({ forbidRepetitions: e.target.checked })}
                                />
                            }
                            label={intl.formatMessage({id: "config.forbid_repetitions"})}
                        />
					</Filters>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose} color="primary">
                        {intl.formatMessage({id: "app.confirm_cancel"})}
                    </Button>
                    <Button disabled={(this.state.create && !this.state.title) || (this.state.custom && !this.state.template)} onClick={this.changeType} color="primary" variant="contained">
                        {intl.formatMessage({id: "app.confirm_save"})}
                    </Button>
                </DialogActions>
            </React.Fragment>
        )
    }
}

const mapStateToProps = ({entities, linkedfield}) => ({
    entities: entities.entities,
	filters: linkedfield.filters
})

export default connect(mapStateToProps, {
	fetchFilterOptions,
	resetFilterOptions
})(injectIntl(LinkedFieldConfig))
